var $form;
var multistepFormInstance;
var currAddress = '';

(function ($) {
    'use strict';

    $(function () {
    var $container = $("#afvalwijzer-request");
    $form = $("#form-afvalwijzer-request");

    var validationOpts = {};
        
    multistepFormInstance = multistepForm($container, validationOpts, afvalwijzerStepValidation, function(){});

}); // End of DOM Ready

})(jQuery);


function afvalwijzerStepValidation(step, callback)
{

    var formData = $form.serializeForm();

    switch (step) {
        // case 1:
            // validateAfvalwijzerRequestedBefore(formData, callback);
            // break;
        case 2:
            validateAfvalwijzerData(formData, callback);
            break;
        case 3:
            submitAfvalwijzerForm(formData, callback);
            break;
        default:
            callback(true);
            break;
    }
}
function removePrevSteps(){
    $("#steps .step.done").remove();
}

function validateAfvalwijzerRequestedBefore(formData, callback){
    if(formData['requested_before']==='yes'){
        callback(false, 'already-requested');
    }
    else {
        callback(true);
    }
}

function validateAfvalwijzerData(formData, callback)
{
    showLoader();
    ajax('validate-afvalwijzer-request', formData, function(response){

        $("#copy_naam").text(formData.name);
        $("#copy_email").text(formData.email);

        $("#autofill_straat").text(response.address.straat);

        var huisnrStr = response.address.huisnummer;
        if(response.address.huisnummerToevoeging !== null) huisnrStr += ' '+response.address.huisnummerToevoeging;

        $("#autofill_huisnummer").text(huisnrStr);

        $("#autofill_postcode").text(response.address.postcode);
        $("#autofill_plaats").text(response.address.plaats);
        $("#autofill_gemeente").text(response.address.gemeente);
        $("#autofill_price").text(response.price);

        showLoader(false);
        callback(true);

    }, function(err){
        console.error(err);
        callback(false, err.message);
        showLoader(false);
    });
}

function submitAfvalwijzerForm(formData, callback)
{
    showLoader();
    ajax('submit-afvalwijzer-request', formData, function(res){
        showLoader(false);
        callback(true);
        removePrevSteps();

    }, function(err){
        console.error(err);
        callback(false, err.message);
        showLoader(false);
    });
}
